import React from "react"
import propTypes from "prop-types"
import { Button } from "reactstrap"
import "assets/scss/custom/components/table-interactive.scss"

const BrandItemList = ({ item, canDelete, canEdit, openEditModal, openDeleteModal }) => {
  const styleCenterTable = { textAlign: "center", verticalAlign: "middle" }
  const renderEditButton = () => {
    if (!canEdit) {
      return null
    }

    return (
      <Button color="primary" className="m-1" onClick={() => openEditModal(item.id)}>
        <i className="fa fa-edit" />
      </Button>
    )
  }

  const renderDeleteButton = () => {
    if (!canDelete) {
      return null
    }

    return (
      <Button color="danger" onClick={() => openDeleteModal(item)}>
        <i className="fa fa-trash" />
      </Button>
    )
  }

  return (
    <tr key={item.id}>
      <td style={styleCenterTable} className="text-cell">
        {item.name}
      </td>
      <td style={styleCenterTable}>
        {renderEditButton()}
        {renderDeleteButton()}
      </td>
    </tr>
  )
}

BrandItemList.propTypes = {
  item: propTypes.object,
  canDelete: propTypes.bool,
  canEdit: propTypes.bool,
  openEditModal: propTypes.func,
  openDeleteModal: propTypes.func,
}

export default BrandItemList
